export const getFriendlyAuthError = (error: any): string => {
  const code = error?.code || '';
  const message = error?.message || '';

  switch (code) {
    case 'auth/invalid-email':
      return 'The email address you entered is not valid. Please check for typos.';
    case 'auth/user-disabled':
      return 'This account has been disabled. If you believe this is an error, please contact support.';
    case 'auth/user-not-found':
    case 'auth/wrong-password':
    case 'auth/invalid-login-credentials':
      return 'Incorrect email or password. Please try again.';
    case 'auth/email-already-in-use':
      return 'An account with this email already exists. Please sign in instead.';
    case 'auth/weak-password':
      return 'Your password is too weak. Please use at least 12 characters.';
    case 'auth/operation-not-allowed':
      return 'This sign-in method is currently disabled. Please contact support.';
    case 'auth/popup-closed-by-user':
      return 'Sign-in was cancelled. Please try again.';
    case 'auth/popup-blocked':
      return 'The sign-in popup was blocked by your browser. Please allow popups for this site.';
    case 'auth/network-request-failed':
      return 'We could not reach the server. Please check your internet connection and try again.';
    case 'auth/too-many-requests':
      return 'Too many failed login attempts. For your security, this account is temporarily locked. Please try again later or reset your password.';
    case 'auth/requires-recent-login':
      return 'For your security, please log in again before performing this sensitive action.';
    case 'auth/credential-already-in-use':
      return 'This account is already linked to another user.';
    case 'auth/account-exists-with-different-credential':
      return 'An account already exists with the same email address but different sign-in credentials. Sign in using a provider associated with this email address.';
    default:
      console.warn("Unhandled Auth Error:", code, message);
      if (message.includes('Cloud Function')) {
          return 'A server error occurred. Please try again later.';
      }
      return 'An unexpected error occurred. Please try again.';
  }
};
